import { render } from "./devto.vue?vue&type=template&id=a611befa&scoped=true"
import script from "./devto.vue?vue&type=script&lang=js"
export * from "./devto.vue?vue&type=script&lang=js"

import "./devto.vue?vue&type=style&index=0&id=a611befa&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a611befa"]])

export default __exports__